export const durationHoursAndMinutes = (duration: number) => {
  if (duration % 60 === 0) return { hours: duration / 60, minutes: 0 };
  return { hours: (duration - (duration % 60)) / 60, minutes: duration % 60 };
};
